module.exports = __webpack_public_path__ + "img/category-popular.ded3001b.png";